import apiClient from "../axiosClient";
import { FieldAlias, FieldAliasRequest } from "../interfaces/field";

export class FieldAliasService {
    
    static async getFieldAliases(loanType: string): Promise<FieldAlias[]> {
        try {
            const response = await apiClient.get("/api/v1/field_alias", {
                params: { loan_type: loanType }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching field aliases:', error);
            throw error;
        }
    }

    static async saveFieldAliases(fieldAliasRequests: FieldAliasRequest[]): Promise<any> {
        try {
            const response = await apiClient.put('/api/v1/field_alias', fieldAliasRequests);
            return response.data;
        } catch (error) {
            console.error('Error saving field aliases:', error);
            throw error;
        }
    }
}

export default FieldAliasService;